import React from 'react';
import LocationTemplate from './LocationTemplate';

const CaryPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Cary"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27511", "27512", "27513", "27518", "27519"]}
      latitude={35.7915}
      longitude={-78.7811}
      population={174880}
      historicalFact="Originally called Bradford's Ordinary; renamed in 1854 after Samuel Fenton Cary, a temperance movement leader."
      nearbyTowns={[
        "Raleigh, NC",
        "Durham, NC",
        "Apex, NC",
        "Morrisville, NC",
        "Holly Springs, NC",
        "Fuquay-Varina, NC",
        "Chapel Hill, NC",
        "Wake Forest, NC"
      ]}
    />
  );
};

export default CaryPage;